// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyColqVTn5w5uh7dz_oTofZBZ8K2sU0tVuk",
  authDomain: "website-5c3aa.firebaseapp.com",
  databaseURL: "https://website-5c3aa.firebaseio.com",
  projectId: "website-5c3aa",
  storageBucket: "website-5c3aa.appspot.com",
  messagingSenderId: "10108387084",
  appId: "1:10108387084:web:b8ff13705dfd2a74"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);


export {storage};